import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../layout/Layout";
import { fetchLocationsWithActivity } from "../../redux/actions/map/mapAsyncActions";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { State } from "../../redux/slices";
import {
  SectionName,
  setConfirmModal,
  setInfoConfirmModal,
  setTabNameLayout,
} from "../../redux/slices/layout";
import {
  initialState,
  resetMapModifyLocation,
  resetMapViewState,
  resetStateMapMessages,
  setModalViewsMap,
  setResetSidebarSearch,
  setSidebarViews,
  setViewValues,
  setViewport,
} from "../../redux/slices/map/map";
import { Viewport } from "../../redux/slices/map/mapTypes";
import InarixMap from "./InarixMapComponent";
import { useTranslation } from "react-i18next";
import { SuccessGeneralModal } from "../SuccessModal";
import { Modal } from "@mui/material";
import { ConfirmGeneralModal } from "../ConfirmModal";
import OverviewUniversalPanel from "./mapFeaturesPanel/MapFeaturesPanel";
import ActionsSpeedDial from "./mapDial/MapDial";

import locationsCreatedSnackBar from "../userLocations/multilocation/InarixTips";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    setTabName: (name: SectionName) => dispatch(setTabNameLayout(name)),
    locationsInit: (token: string) => dispatch(fetchLocationsWithActivity()),
    setNewViewport: (viewport: Viewport) => dispatch(setViewport(viewport)),

    resetAllMapFeatures: () => {
      dispatch(resetMapModifyLocation());
      dispatch(setResetSidebarSearch());
      dispatch(resetStateMapMessages());
      dispatch(setInfoConfirmModal(undefined));
      dispatch(setConfirmModal(false));
      dispatch(setSidebarViews(false));
      dispatch(setModalViewsMap(false));
      dispatch(setViewValues(initialState.viewMapValues));
      dispatch(resetMapViewState());
    },
  };
};

const InarixMapComponent: FC = () => {
  const { locationsInit, setTabName, resetAllMapFeatures } = SetActions();
  const { user, isViewerOnly } = useSelector(
    (state: State) => state.Authentication,
  );
  const { sectionName, confirmModal, infoConfirmModal } = useSelector(
    (state: State) => state.LayoutReducer,
  );
  const { multiLocsCreated, multiLocationCreatedSuccess } = useSelector(
    (state: State) => state.CreateLocationReducer,
  );
  const {
    deleteLocationSuccess,
    isGeoLocUpdated,
    typeOfAction,
    viewport,
    createLocationSuccess,
    createdViewMapSuccess,
    deleteView,
    createLocationActive,
    isGeoLocUpdatedLoading,
    createLocationLoading,
  } = useSelector((state: State) => state.MapReducer);
  const [t] = useTranslation("global");
  const token = user?.token ?? "";

  const successBodyModal = SuccessGeneralModal(t, sectionName, typeOfAction);
  const bodyConfirmModal = ConfirmGeneralModal(
    token,
    t,
    sectionName,
    infoConfirmModal,
    isGeoLocUpdatedLoading || createLocationLoading,
  );

  useEffect(() => {
    resetAllMapFeatures();
    if (user) {
      setTabName("/");
      locationsInit(token);
    }

    locationsInit(token);
  }, []);

  const globalComponentMap = () => (
    <>
      <div className="create-location">
        {!isViewerOnly || !createLocationActive
          ? ActionsSpeedDial(
              token,
              viewport.latitude as number,
              viewport.longitude as number,
              t,
              createLocationActive,
            )
          : ""}
      </div>
      {InarixMap(t, token)}
      {OverviewUniversalPanel(t, token)}
      <Modal
        open={
          deleteLocationSuccess ||
          isGeoLocUpdated ||
          createLocationSuccess ||
          createdViewMapSuccess ||
          deleteView
        }
      >
        {successBodyModal}
      </Modal>
      <Modal open={confirmModal}>{bodyConfirmModal}</Modal>
      {locationsCreatedSnackBar(
        multiLocsCreated,
        t,
        multiLocationCreatedSuccess,
      )}
    </>
  );

  return <Layout component={globalComponentMap()} />;
};

export default InarixMapComponent;
